/**
 * CMC console MapLibre shim.
 *
 * The prototype imported ``maplibre-gl`` from a CDN with its stylesheet pulled in
 * by a ``<link>``. Neither survives the product CSP (``script-src 'self'``, no host),
 * so ops.js and estate.js import this file instead. It pins the CSP distribution and
 * inlines the stylesheet through esbuild's ``.css`` text loader.
 *
 * The bare ``maplibre-gl`` specifier below is rewritten to ``cmc-maplibre-gl`` (5.6.1,
 * the version the console was signed off against) by an esbuild alias in the CMC build
 * pass. The vanilla console keeps 5.24.0. A MapLibre worker only speaks to its own
 * runtime, so this console loads its own worker asset rather than the shared one.
 */
import maplibregl from "maplibre-gl/dist/maplibre-gl-csp";
import mlCss from "maplibre-gl/dist/maplibre-gl.css";

const CSS_ID = "cmc-maplibre-css-injected";
if (typeof document !== "undefined" && mlCss && !document.getElementById(CSS_ID)) {
  const style = document.createElement("style");
  style.id = CSS_ID;
  style.setAttribute("data-cmc", "1");
  style.textContent = mlCss;
  // First in the head, not last. `.maplibregl-map` and `.map-host` carry the
  // same specificity, so whichever lands later wins — appending let the vendor
  // reset `position:relative` beat our `position:absolute;inset:0` and the map
  // collapsed to zero height. Vendor styles are the floor; ours are the answer.
  document.head.prepend(style);
}

// ``document.baseURI`` honours the ``<base href>`` the host page installs from
// ``croc-dashboard-base``, so the worker resolves under ``/console/`` too.
if (typeof document !== "undefined" && typeof maplibregl.setWorkerUrl === "function") {
  maplibregl.setWorkerUrl(new URL("assets/cmc-maplibre-gl-csp-worker.js", document.baseURI).href);
}

export default maplibregl;
